import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { EmailVerifyInput } from '../shared/email-verify-input'
import { OtpVerificationInput } from '../shared/otp-verification-input'

export function LoginEmailCodeForm() {
  const [email, setEmail] = useState('')
  const [isCodeSent, setIsCodeSent] = useState(false)

  return (
    <div className='grid gap-4'>
      {!isCodeSent ? (
        <EmailVerifyInput
          email={email}
          setEmail={setEmail}
          onCodeSent={() => setIsCodeSent(true)}
        />
      ) : (
        <div className='flex flex-col gap-4'>
          <OtpVerificationInput email={email} />
          <Button
            variant='link'
            size='sm'
            className='text-muted-foreground hover:text-primary mx-auto text-xs font-normal'
            onClick={() => setIsCodeSent(false)}
          >
            返回修改邮箱
          </Button>
        </div>
      )}
    </div>
  )
}
